import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const TestTubeIcon: FC<IconProps> = ({
  color = theme.palette.text.primary,
  size = IconSize.medium,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="3.34961"
          y="2.354"
          width="6.5112"
          height="1.67431"
          rx="0.837154"
          transform="rotate(-21.1943 3.34961 2.354)"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
        />
        <mask id="path-2-inside-1_4700_1433" fill="white">
          <path d="M4.64893 3.646L9.3321 1.83005L11.2153 6.68667L6.53213 8.50262L4.64893 3.646Z" />
        </mask>
        <path
          d="M8.21327 2.26388L10.0965 7.12051L12.3341 6.25283L10.4509 1.39621L8.21327 2.26388ZM7.65097 8.06878L5.76776 3.21216L3.53009 4.07984L5.4133 8.93646L7.65097 8.06878Z"
          fill={color}
          mask="url(#path-2-inside-1_4700_1433)"
        />
        <mask id="path-4-inside-2_4700_1433" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1814 6.60004L10.8385 5.71576C10.8113 5.72879 10.7833 5.74243 10.7547 5.75669C9.76641 6.24853 8.95712 6.20385 8.19036 6.16152C7.39993 6.11788 6.65468 6.07674 5.80514 6.62842L5.8051 6.62844L6.56173 8.57972L6.5618 8.5797L10.3656 18.3894C10.8671 19.6826 12.322 20.3245 13.6152 19.823C14.9084 19.3215 15.5502 17.8667 15.0488 16.5734L11.1815 6.60002L11.1814 6.60004Z"
          />
        </mask>
        <path
          d="M10.8385 5.71576L11.9574 5.28192L11.4891 4.07423L10.3206 4.63328L10.8385 5.71576ZM11.1814 6.60004L10.0626 7.03388L10.4964 8.15271L11.6153 7.71887L11.1814 6.60004ZM10.7547 5.75669L10.22 4.68238L10.22 4.68238L10.7547 5.75669ZM8.19036 6.16152L8.12421 7.35969L8.12421 7.35969L8.19036 6.16152ZM5.80514 6.62842L5.15159 5.622L5.15155 5.62203L5.80514 6.62842ZM5.8051 6.62844L5.15151 5.62206L4.33374 6.15315L4.68627 7.06228L5.8051 6.62844ZM6.56173 8.57972L5.4429 9.01356L5.87674 10.1324L6.99557 9.69856L6.56173 8.57972ZM6.5618 8.5797L7.68063 8.14586L7.24679 7.02703L6.12796 7.46087L6.5618 8.5797ZM15.0488 16.5734L16.1676 16.1396L15.0488 16.5734ZM11.1815 6.60002L12.3003 6.16618L11.8665 5.04735L10.7476 5.48118L11.1815 6.60002ZM9.71969 6.1496L10.0626 7.03388L12.3002 6.1662L11.9574 5.28192L9.71969 6.1496ZM11.2893 6.83101C11.3127 6.81939 11.335 6.80848 11.3564 6.79824L10.3206 4.63328C10.2875 4.64911 10.254 4.66548 10.22 4.68238L11.2893 6.83101ZM8.12421 7.35969C8.90925 7.40303 9.9978 7.47377 11.2893 6.83101L10.22 4.68238C9.53503 5.02329 9.00499 5.00466 8.25651 4.96334L8.12421 7.35969ZM6.45869 7.63483C6.9523 7.31429 7.33775 7.31628 8.12421 7.35969L8.25651 4.96334C7.4621 4.91949 6.35706 4.83919 5.15159 5.622L6.45869 7.63483ZM6.45869 7.63483L6.45873 7.63481L5.15155 5.62203L5.15151 5.62206L6.45869 7.63483ZM7.68056 8.14589L6.92393 6.1946L4.68627 7.06228L5.4429 9.01356L7.68056 8.14589ZM6.12796 7.46087L6.12789 7.46089L6.99557 9.69856L6.99564 9.69853L6.12796 7.46087ZM11.4844 17.9555L7.68063 8.14586L5.44297 9.01354L9.24678 18.8232L11.4844 17.9555ZM13.1813 18.7042C12.506 18.966 11.7463 18.6309 11.4844 17.9555L9.24678 18.8232C9.98784 20.7344 12.1379 21.6829 14.049 20.9418L13.1813 18.7042ZM13.93 17.0073C14.1918 17.6826 13.8566 18.4423 13.1813 18.7042L14.049 20.9418C15.9601 20.2008 16.9087 18.0507 16.1676 16.1396L13.93 17.0073ZM10.0626 7.03385L13.93 17.0073L16.1676 16.1396L12.3003 6.16618L10.0626 7.03385ZM11.6153 7.71887L11.6153 7.71885L10.7476 5.48118L10.7476 5.48121L11.6153 7.71887Z"
          fill={color}
          mask="url(#path-4-inside-2_4700_1433)"
        />
      </svg>
    </Icon>
  </>
)
